module.exports = __webpack_public_path__ + "img/pattern_loghi_calcio.65177338.jpg";